// extracted by mini-css-extract-plugin
export default {"page":"XY-z","cartModal":"YY-z","checkout":"ZY-z","placeholder":"_Y-z","account":"aZ-z"};